const _stringToBoolean = value => {
  if (value !== '' && (!value || value.toLowerCase() === 'false')) return false;
  return true;
};

const _stringToArray = value => {
  try {
    return JSON.parse(value);
  } catch (e) {
    console.log(e);
    return [];
  }
};

const _stringToNumber = value => parseInt(value, 10);

class _Emitter<T = void> {
  listeners = new Set<(t: T) => void>();

  addListener(listener: (t: T) => void) {
    this.listeners.add(listener);
  }

  removeListener(listener: (t: T) => void) {
    this.listeners.delete(listener);
  }

  emit = (t: T) => {
    for (const subscription of this.listeners.values()) subscription(t);
    return true;
  };
}

export { _stringToBoolean, _stringToArray, _stringToNumber, _Emitter };
